import { Button, FormControl, InputAdornment, InputLabel, MenuItem, Select, TextField } from "@mui/material";
import styles from "./updatecompanyform.module.css";
import axios from "axios";
import { useEffect } from "react";
import { useForm, Controller } from "react-hook-form";
import { authData } from "../../components/GetAuth";
import { NumericFormat } from "react-number-format";
import { CountryList } from "../../components/Constants";

const UpdateCompanyForm = ({ setFormOpen, onLocal, setSnackbarOpen, setSnackbarMessage, setSnackbarType, setLoading, editData }) => {
  const auth = authData();
  const API_TOKEN = auth?.api_token;

  const { register, handleSubmit, control, setValue, watch, formState: { errors } } = useForm({
    mode: "onChange",
    defaultValues: {
      tax_title: "Tax",
      pickup_country: "",
      delivery_country: "",
    },
  });

  useEffect(() => {
    if (editData) {
      setValue("company_address", editData?.company_address);
      setValue("url_token", editData?.url_token);
      setValue("insurance_charges", editData?.insurance_charges);
      setValue("payment_receiver_account", editData?.payment_receiver_account);
      setValue("payment_receiver_code", editData?.payment_receiver_code);
      setValue("payment_receiver_name", editData?.payment_receiver_name);
      setValue("reg_number", editData?.reg_number);
      setValue("tax_charges", editData?.tax_charges);
      setValue("terms_condition", editData?.terms_condition);
      setValue("vat_number", editData?.vat_number);
      setValue("company_name", editData?.company_name);
      setValue("name", editData?.name);
      setValue("email", editData?.email);
      setValue("phone", editData?.phone);
      setValue("tax_title", editData?.tax_title);
      setValue("pickup_country", editData?.pickup_country);
      setValue("delivery_country", editData?.delivery_country);
      setValue("reference_amount", editData?.reference_amount);

      if (editData?.tax_charges > 0)
        setValue("tax_charges", editData?.tax_charges);
      if (editData?.insurance_charges > 0)
        setValue("insurance_charges", editData?.insurance_charges);
    }
  }, [editData, setValue]);

  const onSubmit = (data) => {
    const formData = new FormData();

    if (data?.address) {
      formData.append("address", data?.address);
    }

    if (data?.url_token) {
      formData.append("url_token", data?.url_token);
      formData.append("domain", data?.url_token + "." + process.env.REACT_APP_BASE_DOMAIN);
    }

    if (data?.company_name) {
      formData.append("company_name", data?.company_name);
    }

    if (data?.delivery_country) {
      formData.append("delivery_country", data?.delivery_country);
    }

    if (data?.insurance_charges) {
      formData.append("insurance_charges", data?.insurance_charges);
    }

    if (data?.name) {
      formData.append("name", data?.name);
    }

    if (data?.payment_receiver_account) {
      formData.append("payment_receiver_account", data?.payment_receiver_account);
    }

    if (data?.payment_receiver_code) {
      formData.append("payment_receiver_code", data?.payment_receiver_code);
    }

    if (data?.payment_receiver_name) {
      formData.append("payment_receiver_name", data?.payment_receiver_name);
    }

    if (data?.phone) {
      formData.append("phone", data?.phone);
    }

    if (data?.pickup_country) {
      formData.append("pickup_country", data?.pickup_country);
    }

    if (data?.reference_amount) {
      formData.append("reference_amount", data?.reference_amount);
    }

    if (data?.reg_number) {
      formData.append("reg_number", data?.reg_number);
    }

    if (data?.tax_charges) {
      formData.append("tax_charges", data?.tax_charges);
    }

    if (data?.tax_title) {
      formData.append("tax_title", data?.tax_title);
    }

    if (data?.terms_condition) {
      formData.append("terms_condition", data?.terms_condition);
    }

    if (data?.vat_number) {
      formData.append("vat_number", data?.vat_number);
    }

    setLoading(true);
    setFormOpen(false);

    axios.post(process.env.REACT_APP_API_URL + "v1/companies/" + editData?.id, formData, {
      headers: {
        Authorization: `Bearer ${API_TOKEN}`,
      }
    }).then((response) => {
      setLoading(false);
      if (response.data.status === "SUCCESS") {
        setSnackbarOpen(true);
        setSnackbarMessage(response.data.message);
        setSnackbarType("success");

        onLocal(response.data.data);
      }

      if (response.data.status === "ERROR") {
        setSnackbarOpen(true);
        setSnackbarMessage(response.data.message);
        setSnackbarType("error");
      }
    }).catch((error) => {
      setLoading(false);
      if (error && error.response && error.response.data && error.response.data.messages) {
        setSnackbarOpen(true);
        setSnackbarMessage(error.response.data.messages);
        setSnackbarType("error");
      }
    });
  }

  return (<form onSubmit={handleSubmit(onSubmit)}>
    <div className={`${styles.FormMainRow}`}>
      <div className={`${styles.FormGroupHalf} FormGroup`}>
        <Controller
          control={control}
          {...register("company_name", {
            required: "This field is Required",
          })}
          render={({ field }) => (<TextField {...field} label="Company Name*" variant="outlined" />)}
        />
        {errors.company_name && (<span className={`ErrorM`}>{errors?.Company_name?.message}</span>)}
      </div>

      <div className={`${styles.FormGroupHalf} FormGroup`}>
        <Controller
          control={control}
          {...register("url_token", {
            required: "This field is Required",
          })}
          render={({ field }) => (<TextField {...field} label="Domain*" variant="outlined" InputProps={{ endAdornment: (<InputAdornment position="end" className="popSuffix">.{process.env.REACT_APP_BASE_DOMAIN}</InputAdornment>) }} />)}
        />
        {errors.url_token && (<span className={`ErrorM`}>{errors?.url_token?.message}</span>)}
      </div>


      <div className={`${styles.FormGroupHalf} FormGroup`}>
        <Controller
          control={control}
          {...register("company_address", {
            required: "This field is Required",
          })}
          render={({ field }) => (<TextField {...field} label="Address*" variant="outlined" />)}
        />
        {errors.company_address && (<span className={`ErrorM`}>{errors?.company_address?.message}</span>)}
      </div>


      <div className={`${styles.FormGroupHalf} FormGroup`}>
        <Controller
          control={control}
          {...register("name", { required: "This field is Required" })}
          render={({ field }) => (<TextField {...field} label="Owner Name*" variant="outlined" />)}
        />
        {errors.name && (<span className={`ErrorM`}>{errors?.name?.message}</span>)}
      </div>
      <div className={`${styles.FormGroupHalf} FormGroup`}>
        <Controller
          control={control}
          {...register("email", {
            required: "This field is Required",
            pattern: {
              value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
              message: "Invalid email address",
            },
          })}
          render={({ field }) => (<TextField {...field} label="Email*" variant="outlined" />)}
        />
        {errors.email && (<span className={`ErrorM`}>{errors?.email?.message}</span>)}
      </div>

      {!editData && (<>
        <div className={`${styles.FormGroupHalf} FormGroup`}>
          <Controller
            {...register("password", {
              required: "This field is Required",
            })}
            control={control}
            render={({ field }) => (<TextField {...field} label="Password*" variant="outlined" type="password" />)}
          />
          {errors.password && (<span className={`ErrorM`}>{errors?.password?.message}</span>)}
        </div>
        <div className={`${styles.FormGroupHalf} FormGroup`}>
          <Controller
            {...register("conf_password", {
              required: "This field is Required",
              validate: (val) => {
                if (watch("password") !== val) {
                  return "Your passwords do no match";
                }
              },
            })}
            control={control}
            render={({ field }) => (<TextField {...field} id="outlined-basic" label="Confirm Password*" variant="outlined" type="password" />)}
          />
          {errors.conf_password && (<span className={`ErrorM`}>{errors?.conf_password?.message}</span>)}
        </div>
      </>)}

      <div className={`${styles.FormGroupHalf} FormGroup`}>
        <Controller
          control={control}
          {...register("phone", { required: "This field is Required", })}
          render={({ field }) => (<TextField {...field} label="Phone*" variant="outlined" />)}
        />
        {errors.phone && (<span className={`ErrorM`}>{errors.phone.message}</span>)}
      </div>

      <div className={`${styles.FormGroupHalf} FormGroup`}>
        <Controller
          control={control}
          {...register("reg_number")}
          render={({ field }) => (<TextField {...field} label="Register No" variant="outlined" />)}
        />
        {errors.reg_number && (<span className={`ErrorM`}>{errors?.reg_number?.message}</span>)}
      </div>

      <div className={`${styles.FormGroupHalf} FormGroup`}>
        <Controller
          control={control}
          {...register("vat_number")}
          render={({ field }) => (<TextField {...field} label="Vat Number" variant="outlined" />)}
        />
        {errors.vat_number && (<span className={`ErrorM`}>{errors?.vat_number?.message}</span>)}
      </div>

      <div className={`${styles.FormGroupHalf} FormGroup`}>
        <Controller
          control={control}
          {...register("payment_receiver_name")}
          render={({ field }) => (<TextField {...field} label="Payment Receiver Name" variant="outlined" />)}
        />
        {errors.payment_receiver_name && (<span className={`ErrorM`}>{errors?.payment_receiver_name?.message}</span>)}
      </div>


      <div className={`${styles.FormGroupHalf} FormGroup`}>
        <Controller
          control={control}
          {...register("payment_receiver_account")}
          render={({ field }) => (<TextField {...field} label="Payment Receiver Account" variant="outlined" />)}
        />
        {errors.payment_receiver_account && (<span className={`ErrorM`}>{errors?.payment_receiver_account?.message}</span>)}
      </div>

      <div className={`${styles.FormGroupHalf} FormGroup`}>
        <Controller
          control={control}
          {...register("payment_receiver_code")}
          render={({ field }) => (<TextField {...field} label="Payment Receiver Code" variant="outlined" />)}
        />
        {errors.payment_receiver_code && (<span className={`ErrorM`}>{errors?.payment_receiver_code?.message}</span>)}
      </div>



      <div className={`${styles.FormGroupHalf} FormGroup`}>
        <Controller
          control={control}
          {...register("tax_title", { required: "This field is Required" })}
          render={({ field }) => (<TextField {...field} label="Tax Title*" variant="outlined" />)}
        />
        {errors.tax_title && (<span className={`ErrorM`}>{errors?.tax_title?.message}</span>)}
      </div>



      <div className={`${styles.FormGroupHalf} FormGroup`}>
        <Controller
          control={control}
          {...register("tax_charges")}
          render={({ field }) => (<NumericFormat {...field} label="Tax Charges(%)" variant="outlined" customInput={TextField} allowLeadingZeros={false} allowNegative={false} decimalScale={2} fixedDecimalScale />)}
        />
        {errors.tax_charges && (<span className={`ErrorM`}>{errors?.tax_charges?.message}</span>)}
      </div>
      <div className={`${styles.FormGroupHalf} FormGroup`}>
        <Controller
          control={control}
          {...register("insurance_charges")}
          render={({ field }) => (<NumericFormat {...field} label="Insurance Charges" variant="outlined" customInput={TextField} allowLeadingZeros={false} allowNegative={false} decimalScale={2} fixedDecimalScale />)}
        />
        {errors.insurance_charges && (<span className={`ErrorM`}>{errors?.insurance_charges?.message}</span>)}
      </div>
      <div className={`${styles.FormGroupHalf} FormGroup`}>
        <FormControl fullWidth>
          <InputLabel id="demo-simple-select-label">Pickup Country*</InputLabel>
          <Controller
            control={control}
            {...register("pickup_country", {
              required: "This field is required",
            })}
            render={({ field }) => (<Select label="Pickup Country*" {...field}>
              <MenuItem value={"GB"}>United Kingdom</MenuItem>
            </Select>)}
          />
        </FormControl>
        {errors.pickup_country && (<span className={`ErrorM`}>{errors?.pickup_country?.message}</span>)}
      </div>
      <div className={`${styles.FormGroupHalf} FormGroup`}>
        <FormControl fullWidth>
          <InputLabel id="demo-simple-select-label">Delivery Country*</InputLabel>
          <Controller
            control={control}
            {...register("delivery_country", {
              required: "This field is required",
            })}
            render={({ field }) => (<Select label="Delivery Country*" {...field}>
              {CountryList?.map((i) => {
                return (<MenuItem key={i?.value} value={i?.value}>{i?.label}</MenuItem>);
              })}
            </Select>)}
          />
        </FormControl>
        {errors.delivery_country && (<span className={`ErrorM`}>{errors?.delivery_country?.message}</span>)}
      </div>
      <div className={`${styles.FormGroupHalf} FormGroup`}>
        <Controller
          control={control}
          {...register("reference_amount")}
          render={({ field }) => (<NumericFormat {...field} label="Reference Amount" variant="outlined" customInput={TextField} allowLeadingZeros={false} allowNegative={false} decimalScale={2} fixedDecimalScale />)}
        />
        {errors.reference_amount && (<span className={`ErrorM`}>{errors?.reference_amount?.message}</span>)}
      </div>

      <div className={`${styles.FormGroupFull} FormGroup`}>
        <Controller
          control={control}
          {...register("terms_condition")}
          render={({ field }) => (<TextField {...field} label="Terms & Condition" variant="outlined" multiline minRows={4} />)}
        />
        {errors.terms_condition && (<span className={`ErrorM`}>{errors?.terms_condition?.message}</span>)}
      </div>
    </div>

    <div className="ButtonAction">
      <Button className="CancelPopupBU" onClick={(e) => setFormOpen(false)}>Cancel</Button>
      <Button className="SubmitPopupBU" type="submit">Update</Button>
    </div>
  </form>);
};

export default UpdateCompanyForm;